module.exports = __webpack_public_path__ + "static/02-736c463e8bf13b05280b2fef6ada2220.jpg";